export const desktopTooltips = [
  {
    title: 'Tool Tips',
    bodyText: 'Please save this page to your Bookmarks for easy reference later.',
    buttonText: 'Next Tip',
  },
  {
    title: 'Tool Tips',
    bodyText:
      'Make sure to open this page on your mobile device before you travel. This will enable you to also have access to everything offline.',
    buttonText: 'Next Tip',
  },
  {
    title: 'Tool Tips',
    bodyText: 'To access any documents while offline, please download them first now.',
    buttonText: 'Close',
  },
];

export const mobileTooltips = [
  {
    title: 'Tool Tips',
    bodyText:
      'Please explore both Part I and Part II of your portal now to unlock full offline access at any point later.',
    buttonText: 'Next Tip',
  },
  {
    title: 'Tool Tips',
    bodyText:
      'You can save this page to your homescreen by clicking the share button and then Add to Homescreen, for easy reference later.',
    buttonText: 'Next Tip',
  },
  {
    title: 'Tool Tips',
    bodyText: 'To access any documents while offline, please download them first now.',
    buttonText: 'Close',
  },
];
